
<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Verification</h4>
                </div>

                <div  v-if="status != 'loading'">
               
<vs-alert active="true" class="my-5" icon-pack="feather" icon="icon-check" :color="status ? 'success' : 'danger'">
 {{ status ? ' Your account activated succesfully' : "We couldn't activate your account."}}
</vs-alert>
                  <p v-if="status">Now you can login to your account.</p>
                  
                 
                

                 

                  <div v-if="status" class="social-login-buttons flex flex-wrap items-center mt-4 justify-center">
                    <vs-button to="/login"  type="flat">Login</vs-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      status:'loading'
    }
  },
  created(){
      this.activateUser();
  },
 
   methods: {


    activateUser () {


        const payload = this.$route.query.token
            
      


       this.$store.dispatch('auth/activate', payload)
        .then((response) => { this.status = response.data.result })
        .catch(error => {
            this.status = false
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })


    //   this.$router.push('/pages/register').catch(() => {})
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
